import {AppState} from '../AppState';

export const getService = (store: AppState) => store.service;
